var _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 533.5594869243255 114.45437938313916",
    height: 84.84339093016573,
    width: 395.5199999999999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 7.468606403539083,
    height: 99.38151610692256,
    x: 415.07132566371484,
    y: 7.536431638108297,
    fill: "#6a704c",
    opacity: 1,
    strokeWidth: 0,
    stroke: "transparent",
    fillOpacity: 1,
    className: "rect-r-0",
    "data-fill-palette-color": "primary",
    rx: "1%",
    id: "r-0",
    "data-palette-color": "#6a704c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,15.81822464701851)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 82.81793008910213",
    height: 82.81793008910213,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 82.81793008910213",
    height: 82.81793008910213,
    width: 395.52,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 82.81793008910213",
    height: 82.81793008910213,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    viewBox: "3.1500000953674316 -29.950000762939453 145.8800048828125 30.55000114440918",
    height: 82.81793008910213,
    "data-palette-color": "#6a704c",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0L3.15 0 3.15-29.55 6.85-29.55 13.25-5.5 19.8-29.55 23.35-29.55 23.35 0 20.55 0 20.55-23.9 14.4 0 12.15 0 6-23.9 6 0ZM42.4 0L29.65 0 29.65-29.55 42.4-29.55 42.4-27.3 32.9-27.3 32.9-16.7 40.5-16.7 40.5-14.2 32.9-14.2 32.9-2.25 42.4-2.25 42.4 0ZM55.2 0L46.74 0 46.74-29.55 55.59-29.55Q57.49-29.55 58.87-29 60.25-28.45 60.97-27.13 61.7-25.8 61.7-23.5L61.7-23.5 61.7-6.45Q61.7-3.9 60.89-2.5 60.09-1.1 58.62-0.55 57.14 0 55.2 0L55.2 0ZM49.99-27.65L49.99-1.8 54.8-1.8Q56.49-1.8 57.52-2.73 58.55-3.65 58.55-6.3L58.55-6.3 58.55-23.1Q58.55-25.75 57.52-26.7 56.49-27.65 54.8-27.65L54.8-27.65 49.99-27.65ZM70.69 0L67.54 0 67.54-29.55 70.69-29.55 70.69 0ZM83.94 0.6L83.94 0.6Q81.74 0.6 80.07 0.1 78.39-0.4 77.42-1.98 76.44-3.55 76.44-6.75L76.44-6.75 76.44-23.4Q76.44-26.2 77.42-27.6 78.39-29 80.12-29.48 81.84-29.95 83.99-29.95L83.99-29.95Q86.19-29.95 87.84-29.45 89.49-28.95 90.44-27.55 91.39-26.15 91.39-23.4L91.39-23.4 91.39-18.2 88.24-18.2 88.24-23.45Q88.24-25.4 87.69-26.38 87.14-27.35 86.17-27.65 85.19-27.95 83.94-27.95L83.94-27.95Q82.69-27.95 81.72-27.65 80.74-27.35 80.22-26.38 79.69-25.4 79.69-23.45L79.69-23.45 79.69-5.9Q79.69-3.9 80.22-2.93 80.74-1.95 81.72-1.65 82.69-1.35 83.94-1.35L83.94-1.35Q85.24-1.35 86.19-1.65 87.14-1.95 87.69-2.93 88.24-3.9 88.24-5.9L88.24-5.9 88.24-10.35 91.39-10.35 91.39-6.8Q91.39-3.55 90.44-1.98 89.49-0.4 87.84 0.1 86.19 0.6 83.94 0.6ZM97.79 0L94.49 0 101.04-29.55 105.09-29.55 111.54 0 108.14 0 106.54-6.85 99.29-6.85 97.79 0ZM102.99-25.7L99.39-8.6 106.49-8.6 102.99-25.7ZM121.44 0.35L121.44 0.35Q119.19 0.35 117.56-0.45 115.94-1.25 115.04-3.13 114.14-5 114.14-8.35L114.14-8.35 114.14-10Q114.94-10 115.76-10 116.59-10 117.34-10L117.34-10 117.34-8.15Q117.34-5.65 117.86-4.28 118.39-2.9 119.31-2.35 120.24-1.8 121.44-1.8L121.44-1.8Q123.39-1.8 124.61-3.03 125.84-4.25 125.84-7.4L125.84-7.4Q125.84-9.65 125.19-10.78 124.54-11.9 123.19-12.58 121.84-13.25 119.89-14.05L119.89-14.05Q118.29-14.7 117.01-15.63 115.74-16.55 115.04-18.05 114.34-19.55 114.34-21.85L114.34-21.85Q114.34-24.45 115.04-26.18 115.74-27.9 117.34-28.75 118.94-29.6 121.59-29.6L121.59-29.6Q125.04-29.6 126.91-27.88 128.79-26.15 128.79-23L128.79-23 128.79-19.75Q128.04-19.75 127.26-19.75 126.49-19.75 125.69-19.75L125.69-19.75 125.69-22.25Q125.69-24.65 124.66-25.88 123.64-27.1 121.64-27.1L121.64-27.1Q119.44-27.1 118.46-25.83 117.49-24.55 117.49-21.95L117.49-21.95Q117.49-20 118.24-18.88 118.99-17.75 120.19-17.13 121.39-16.5 122.74-16L122.74-16Q124.99-15.15 126.39-14.23 127.79-13.3 128.44-11.85 129.09-10.4 129.09-7.8L129.09-7.8Q129.09-4.75 128.11-2.98 127.14-1.2 125.41-0.43 123.69 0.35 121.44 0.35ZM137.28 0L134.13 0 134.13-29.55 137.28-29.55 137.28-16.65 145.93-16.65 145.93-29.55 149.03-29.55 149.03 0 145.93 0 145.93-14.25 137.28-14.25 137.28 0Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#6a704c",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,442.0912577309688,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 91.46822919335666 114.45437938313916",
    height: 114.45437938313916,
    width: 91.46822919335666,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "11.600000381469727 2.4000000953674316 76.80000305175781 96.0999984741211",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    height: 114.45437938313916,
    width: 91.46822919335666,
    className: "icon-icon-0",
    "data-fill-palette-color": "accent",
    id: "icon-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3 29.9L88.2 29.5C88 28.9 87.7 28.4 87.3 28L63.2 3.6C62.9 3.3 62.6 3.1 62.2 2.9L60.9 2.5 22.8 2.4C16.6 2.4 11.6 7.4 11.6 13.6V87.3C11.6 93.5 16.6 98.5 22.8 98.5H77.2C83.4 98.5 88.4 93.5 88.4 87.3V30.9zM63.4 15.3L76 28.1H66.6C64.9 28.1 63.5 26.7 63.5 25V15.3zM45.7 40.9H39.1V47.5C39.1 48.9 37.9 50.1 36.5 50.1S33.9 48.9 33.9 47.5V40.9H27.3C25.9 40.9 24.7 39.7 24.7 38.3S25.9 35.7 27.3 35.7H33.9V29.1C33.9 27.7 35.1 26.5 36.5 26.5S39.1 27.7 39.1 29.1V35.7H45.7C47.1 35.7 48.3 36.9 48.3 38.3S47.1 40.9 45.7 40.9M77.6 86H62.3V82.3H77.5V86zM77.6 76.3H49.2V72.6H77.6zM77.6 66.9H49.2V63.2H77.6z",
    fill: "#412e27",
    "data-fill-palette-color": "accent"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3b848f7e5fb8a07209aec77c15a4259b.svg";
export { ForwardRef as ReactComponent };